<template>
    <div class="yt-video">
        <h3 v-if="title" v-html="title"></h3>
        <div class="play" @click.stop="openVideo">
            <img class="thumb" :src="`https://i.ytimg.com/vi/${this.id}/maxresdefault.jpg`" alt="">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 283.46 283.46" class="action">
                <path d="M142.07,280a138.2,138.2,0,1,1,57.32-12.58A138,138,0,0,1,142.07,280Zm-.13-254.17a116.38,116.38,0,1,0,40.56,7.35A115.71,115.71,0,0,0,141.94,25.83Z"/>
                <path d="M238,135.07,99,54.79A7.52,7.52,0,0,0,87.71,61.3V221.86A7.52,7.52,0,0,0,99,228.38L238,148.1A7.52,7.52,0,0,0,238,135.07Z"/>
            </svg>
        </div>
        <div class="overlay" v-if="open">
            <div class="control">
                <button @click.stop="closeVideo">Tilbage til Coding Class Odense</button>
            </div>
            <iframe :src="`https://www.youtube.com/embed/${this.id}?autoplay=1&fs=0&rel=0`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
    </div>
</template>

<script>
export default {
  name: 'YouTubeEmbed',
  props: [
      "id",
      "title"
  ],
  data(){
      return {
          open: false,
          y: 0
      }
  },
  methods: {
      openVideo: function() {
        const el = window;
        this.y = el.pageYOffset !== undefined ? el.pageYOffset : el.scrollTop
        document.body.style.overflowY = 'hidden';
        this.open = true;
        return true;
      },
      closeVideo: function() {
          document.body.removeAttribute('style');
          window.scrollTo(0, this.y);
          this.open = false;

          return true;
      }
  }
}
</script>

<style>
    .yt-video {
        position: relative;
        margin: 0 auto;
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .play {
        position: relative;
        width: 560px; 
        height: 315px;
        margin: 0 auto;
        cursor: pointer;
    }
    .play:hover .action {
        /*fill: #ff00f9;*/
        fill: #00ffd4;
    }
    .play .thumb {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;

    }
    .play .action {
        position: absolute;
        top: calc(50% - 50px);
        left: calc(50% - 50px);
        height: 100px;
        width: 100px;
        z-index: 2;
        fill: #e0ff00;

    }
    .overlay {
        position: fixed;
        z-index: 3;
        top: 40px;
        left: 0;
        height: 100vh;
        width: 100vw;
        background-color: #000;
    }
    .overlay .control {
        background: #000;
        position: fixed;
        top: 0;
        left: 0;
        height: 40px;
        width: 100vw;
    }
    .overlay .control button {
        font-size: 14px;
        color: #fff;
        border: 2px solid #fff;
        border-radius: 40px;
        background-color: #000;
        padding: 6px 20px;
        margin-top: 3px;
        cursor: pointer;
        float: right;
    }
    .overlay iframe {
        height: calc(100vh - 40px);
        width: 100vw;
    }
</style>


// WEBPACK FOOTER //
// src/components/YoutubeEmbed.vue